var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive }
  ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Mitglieder',
          icon: 'people',
          path: '/mitglieder'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Nicht-Mitglieder',
          icon: 'people_outline',
          path: '/nicht-mitglieder'
        }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Kontakte', icon: 'contacts', path: '/kontakte' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Statistiken', icon: 'bar_chart', path: '/kontakte' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Aktueller Stand',
            path: '/statistiken/aktuell'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Ab-/Zugänge',
            path: '/statistiken/ab-zugaenge'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Trends - Bar',
            path: '/statistiken/trends-bar'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Trends - Line',
            path: '/statistiken/trends-line'
          }}})],1),_c('sidebar-item',{attrs:{"link":{ name: 'Listen', icon: 'list', path: '/listen' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Ansprechpartner',
            path: '/listen/ansprechpartner'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Emails',
            path: '/listen/emails'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Kategorien',
            path: '/listen/kategorien'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Services',
            path: '/listen/services'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Rechnungen',
          icon: 'receipt',
          path: '/rechnungen'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Liste Ausgang',
            path: '/rechnungen/liste-ausgang'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Jahresrechnungen',
            path: '/rechnungen/jahresrechnungen'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Organisation',
          icon: 'business_center',
          path: '/organisation'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Aufgaben',
            path: '/organisation/aufgaben'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Termine',
            path: '/organisation/termine'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Nachrichten',
            path: '/organisation/nachrichten'
          }}})],1),(_vm.hasPermission('view clubsettings'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Einstellungen',
          icon: 'settings',
          path: '/einstellungen'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Verein',
            path: '/einstellungen/verein'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Benutzerkonten',
            path: '/einstellungen/benutzerkonten'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Mitgliedskategorien',
            path: '/einstellungen/mitgliedskategorien'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Services',
            path: '/einstellungen/services'
          }}})],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }